module.exports = __webpack_public_path__ + "img/wm-1.b9786925.png";